import React, { useEffect, useState } from 'react';
import Section from '../common/Section';
import styles from '../../styles/modules/components/infographics.module.scss';


const InfoGraphics = (props:any) => {
    return (
        <Section className={`section_custompad ${props.bgColor ? `${props.bgColor}` : ""}`.trim()} title={props.variant === 'secondary' && props.title ? props.title : '' } hasPadding={props.variant === 'secondary' && props.title ? true : false}>
            <div className={`${styles.section__nopad}`} data-variant={props.variant === 'secondary' ? 'secondary' : 'primary'}>
                <div className={`container ${styles.container}`}>
                    <div className={`${styles.section__infograph} row`}>
                        <div className={`${styles.infograph__pad1} col-4`}>
                            <span className={`${styles.infograph__item}`}>10,000</span><span className={`${styles.info__small}`}>+</span>
                            <p>Retail Stores</p>
                            <div className={`${styles.infograph__firstbg} `}></div>
                        </div >
                        <div className={`${styles.infograph__pad2} col-4`}>
                            <span className={`${styles.infograph__item}`}>3,300</span><span className={`${styles.info__small}`}>+</span>
                            <p>Service Centers</p>

                            <div className={`${styles.infograph__secondbg}  `}></div>
                        </div>
                        <div className={`${styles.infograph__pad3} col-4`}>
                            <span className={`${styles.infograph__item}`}>2.5</span><span className={`${styles.info__small}`}>+</span>
                            <p>Crore Customers</p>

                            <div className={`${styles.infograph__thirdbg}`}></div>
                        </div>
                    </div>
                </div>
            </div>
        </Section >


    )
}



export default InfoGraphics;